import { Button } from '@ph-react-ui/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  isPaymentSystemLocked,
  PaymentLockdownBanner,
} from '../../utils/constants/payments/payment-lockdown';

export function Payments() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isLocked = useMemo(() => isPaymentSystemLocked(), []);
  const { month, year } = useMemo(() => {
    const currentDate = new Date();
    return {
      month: currentDate.getMonth() + 1,
      year: currentDate.getFullYear(),
    };
  }, []);

  const onNavigateToFoodPaymentPage = () => {
    navigate(`monthly-menu?year=${year}&month=${month}`);
  };
  const onNavigateToFoodPaymentHistory = () => {
    navigate('/dashboard/payments/monthly-menu/history');
  };

  const onNavigateToTransportPaymentPage = () => {
    navigate(`transport?year=${year}&month=${month}`);
  };
  const onNavigateToTransportHistoryPage = () => {
    navigate(`transport/history?year=${year}&month=${month}`);
  };

  const onNavigateToSchoolTaxesPage = () => {
    navigate('school-taxes');
  };
  const onNavigateToSchoolTaxPaymentsHistory = () => {
    navigate('/dashboard/payments/school-taxes/history');
  };

  return (
    <div className="payments fixed-width">
      <PaymentLockdownBanner />
      <div className="payments__item">
        <div className="payments__item__titles">
          <h2 className="payments__item__titles__h2">
            {t('PAYMENTS.TITLES.SCHOOL_TAXES')}
          </h2>
          <button
            className="payments__item__titles__button"
            onClick={onNavigateToSchoolTaxPaymentsHistory}
          >
            {t('ACTIONS.PAYMENT_HISTORY')}
          </button>
        </div>
        <div className="payments__item__actions">
          <Button
            className="payments__item__actions__pay"
            onClick={onNavigateToSchoolTaxesPage}
            disabled={isLocked}
          >
            {t('ACTIONS.PREVIEW_PAYMENT')}
          </Button>
        </div>
      </div>
      <div className="payments__item">
        <div className="payments__item__titles">
          <h2 className="payments__item__titles__h2">
            {t('PAYMENTS.TITLES.FOOD')}
          </h2>
          <button
            className="payments__item__titles__button"
            onClick={onNavigateToFoodPaymentHistory}
          >
            {t('ACTIONS.PAYMENT_HISTORY')}
          </button>
        </div>
        <div className="payments__item__actions">
          <Button
            className="payments__item__actions__pay"
            onClick={onNavigateToFoodPaymentPage}
            disabled={isLocked}
          >
            {t('ACTIONS.PREVIEW_PAYMENT')}
          </Button>
        </div>
      </div>
      <div className="payments__item">
        <div className="payments__item__titles">
          <h2 className="payments__item__titles__h2">
            {t('PAYMENTS.TITLES.TRANSPORT')}
          </h2>
          <button
            className="payments__item__titles__button"
            onClick={onNavigateToTransportHistoryPage}
          >
            {t('ACTIONS.PAYMENT_HISTORY')}
          </button>
        </div>
        <div className="payments__item__actions">
          <Button
            className="payments__item__actions__pay"
            onClick={onNavigateToTransportPaymentPage}
          >
            {t('ACTIONS.PREVIEW_PAYMENT')}
          </Button>
        </div>
      </div>
    </div>
  );
}
